import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import ChemicalCounterpartCreateFromCSVPage from 'chemistry/ChemicalCounterpartCreateFromCSVPage';
import {
  createSaltsFromFile,
  SALT_LIBRARY_URL,
  TEMPLATE_BULK_SALTS_CSV_LINK,
  validateSaltsFromFile,
} from 'chemistry/ChemistryDAO';
import {getApolloClient} from 'graphql-client/ApolloClient';

import {SALT_LIBRARY_QUERY} from './SaltLibrary';

export default function SaltCreateFromCSVPage(): JSX.Element | null {
  useEffect(() => {
    setWindowTitle('Import salts');
  }, []);

  return (
    <ChemicalCounterpartCreateFromCSVPage
      counterpartName="salt"
      libraryUrl={SALT_LIBRARY_URL}
      templateCSVLink={TEMPLATE_BULK_SALTS_CSV_LINK}
      validate={validateSaltsFromFile}
      createFromFile={createSaltsFromFile}
      onImportSuccess={async () => {
        await getApolloClient().refetchQueries({include: [SALT_LIBRARY_QUERY]});
      }}
      dataTestComponent="SaltCreateFromCSVPage"
    />
  );
}
